import Modal from "react-responsive-modal";
import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { materialTableStyle, newModalStyle } from "../../reusable/styles";
import MaterialTable from "@material-table/core";
import { getAuditTickets } from "../../actions/violations";
import { useTranslation } from "react-i18next";
import { cellStyle, headerStyle } from "../../columns/columnsGeneral";
import moment from "moment";
import { optionsAudit } from "../../reusable/optionsForTables";

const ModalAuditTicket = (props) => {
  const { open, close, ticketForAudit } = props;
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAuditTickets(ticketForAudit)
      .then((data) => {
        setRows(data ?? []);
        setFailed(data === null);
      })
      .finally(() => setLoading(false));
  }, [ticketForAudit]);

  return (
    <Modal
      open={open}
      closeOnEsc
      onClose={close}
      center
      styles={newModalStyle()}
    >
      <div style={{ margin: "10px" }}>
        {failed ? (
          <div>{t("AuditTicket.LoadError")}</div>
        ) : (
        <MaterialTable
          title={t("AuditTicket.History")}
          style={materialTableStyle}
          data={rows}
          isLoading={loading}
          options={optionsAudit()}
          columns={[
            {
              title: t("AuditTicket.ModifiedOn"),
              field: "modifiedOn",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => (
                <>{moment(row.modifiedOn).format("DD.MM.YYYY")}</>
              ),
            },
            {
              title: t("AuditTicket.StatusUntil"),
              field: "statusUntil",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
              render: (row) => (
                <>{moment(row.statusUntil).format("DD.MM.YYYY")}</>
              ),
            },
            {
              title: t("AuditTicket.Status"),
              field: "status",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
            {
              title: t("AuditTicket.LegalStatus"),
              field: "legalStatus",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
            {
              title: t("AuditTicket.PaidAmount"),
              field: "paidAmount",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
            {
              title: t("AuditTicket.Amount"),
              field: "amount",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
            {
              title: t("AuditTicket.ModifiedBy"),
              field: "modifiedBy",
              cellStyle: cellStyle,
              headerStyle: headerStyle,
            },
          ]}
        />
        )}
      </div>
    </Modal>
  );
};
export default ModalAuditTicket;
